import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHelmet = ({
  title,
  description,
  canonicalPath = '/',
  ogImage = '/og-image.png',
  ogType = 'website',
  breadcrumbs,
}) => {
  const siteUrl = 'https://finance-forecaster.com';
  const fullTitle = title
    ? `${title} | Finance Forecaster`
    : 'Finance Forecaster - Know What You Can Spend Before You Spend It';

  // Build BreadcrumbList JSON-LD if breadcrumbs provided
  // breadcrumbs: [{ name: 'Home', path: '/' }, { name: 'Blog', path: '/blog' }]
  const breadcrumbJsonLd = breadcrumbs
    ? JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: breadcrumbs.map((crumb, i) => ({
          '@type': 'ListItem',
          position: i + 1,
          name: crumb.name,
          item: `${siteUrl}${crumb.path}`,
        })),
      })
    : null;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={`${siteUrl}${canonicalPath}`} />

      {/* Open Graph */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={`${siteUrl}${canonicalPath}`} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={`${siteUrl}${ogImage}`} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={`${siteUrl}${canonicalPath}`} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${siteUrl}${ogImage}`} />

      {/* BreadcrumbList structured data */}
      {breadcrumbJsonLd && (
        <script type="application/ld+json">{breadcrumbJsonLd}</script>
      )}
    </Helmet>
  );
};

export default SEOHelmet;
